module.exports = __webpack_public_path__ + "img/bg4.09d42838.png";